import gql from 'graphql-tag';

export const LISTING_MORE_INFORMATION_FRAGMENT = gql`
    fragment LISTING_MORE_INFORMATION_FRAGMENT on ListingData {
        embeddedContent {
            videos {
                url
            }
            tours {
                url
            }
            smartViewings {
                url
            }
            links {
                url
            }
        }
        content {
            floorPlan {
                original
            }
        }
        epc {
            image {
                url
            }
            pdf {
                original
            }
        }
        location {
            coordinates {
                latitude
                longitude
            }
        }
        marketStats {
            askingPrices {
                toRent {
                    meanValue
                }
            }
            historicalEstimates {
                date
            }
            sales {
                mean
            }
            recentSales {
                date
            }
        }
    }
`;
